import { render, staticRenderFns } from "./GameClass.vue?vue&type=template&id=0fe48764&scoped=true&"
import script from "./GameClass.vue?vue&type=script&lang=js&"
export * from "./GameClass.vue?vue&type=script&lang=js&"
import style0 from "./GameClass.vue?vue&type=style&index=0&id=0fe48764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe48764",
  null
  
)

export default component.exports